import React, { FC, ComponentProps } from 'react';
import { CSSProp } from 'styled-components';
import Button from '@adsk/alloy-react-button';
import Tooltip from '@adsk/alloy-react-tooltip';
import i18n from '../helpers/i18n';

export type MaintenanceModeButtonProps = {
  isMaintenanceMode: boolean;
  isTemplate?: boolean;
} & ComponentProps<typeof Button>;

const buttonStyle = {
  marginRight: 10,
  whiteSpace: 'nowrap',
} as CSSProp;

export const MaintenanceModeButton: FC<MaintenanceModeButtonProps> = ({
  isTemplate = false,
  isMaintenanceMode,
  ...rest
}) => {
  const content = isTemplate
    ? i18n.t('TEMPLATE_CREATION_MAINTENANCE_MODE')
    : i18n.t('PROJECT_CREATION_MAINTENANCE_MODE');

  return isMaintenanceMode ? (
    <Tooltip placement={Tooltip.PLACEMENTS.TOP} content={content}>
      <Button style={buttonStyle} disabled {...rest} />
    </Tooltip>
  ) : (
    <Button style={buttonStyle} {...rest} />
  );
};
